<template>
  <div class="home">
    <div class="ticketList">
      <div class="codeList" v-for="(item, index) in list" :key="item.id">
        <i class="el-icon-film"></i>
        <div class="ticketHone" :index="index" @click="redraw(index)">
          <p>{{ item.name }}</p>
          <p v-if="item.type == 1">类型：时间减免</p>
          <p v-if="item.type == 2">类型：金额减免</p>
          <p v-if="item.type == 3">类型：折扣减免</p>
          <p v-if="item.type == 4">类型：全免</p>
          <p>总数：{{ item.total }} 剩余：{{ item.count }}</p>
          <p v-if="item.unit === 1">额度：{{ item.value }}小时</p>
          <p v-if="item.unit === 2">额度：{{ item.value }}分钟</p>
          <p v-if="item.unit === 3">额度：{{ item.value }}天</p>
          <p v-if="item.unit === 4">额度：{{ item.value }}元</p>
          <p v-if="item.unit === 5">额度：{{ item.value }}折</p>
          <p v-if="item.unit === 6">额度：全免</p>

          <p>截止时间：{{ item.codeEndTime }}</p>
          <p>固定码名称：{{ item.remark }}</p>
        </div>
        <div class="operate">
          <i class="el-icon-edit-outline" @click="redact(index)"></i>
          <i class="el-icon-delete" @click="del(index)"></i>
        </div>
      </div>
      <div class="paging">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-sizes="[20, 40, 60, 80, 100]"
          :page-size="limit"
          layout="sizes, prev, pager, next"
          :total="count"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="新增券张数"
      :visible.sync="dialogVisible"
      width="25%"
      :before-close="handleClose"
    >
      <div class="compile">
        <p>券编码：{{ present.name }}</p>
        <p>
          新增张数：<el-input-number
            v-model="num"
            @change="handleChange"
            :min="1"
            :max="9999"
          ></el-input-number>
        </p>
        <p>
          <span class="demonstration">截止日期：</span>
          <el-date-picker
            v-model="value1"
            type="datetime"
            placeholder="选择日期时间"
            :clearable="false"
            format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <div class="hint">点击券内容处可以重新生成二维码</div>
    <div class="qrs" v-show="show">
      <div class="poster-container" ref="imageTofile">
        <div class="poster-bg-img">
          <div class="poster-bg-mask"></div>
          <p class="time">{{ present.codeBeginTime }}</p>
          <p class="quantity">总张数{{ present.total }}张</p>
          <p class="fixedName">{{ present.remark }}</p>
        </div>
        <div class="poster-content">s
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </div>
      <!-- 最终生成的海报图片 -->
      <div id="page">
        <span class="del" @click="delte">X</span>
        <div class="exhibition">
          <img id="posterImg" :src="imgsrc" />
          <a
            class="btn btn-sm btn-info pull-right"
            id="export"
            :href="imgsrc"
            download="固定优惠码.png"
          >
            <i class="ace-icon fa fa-download bigger-120"></i>下载二维码
          </a>
          <b class="iconfont icon-printguanbi shut"></b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { util } from "../utils/global";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      shopData: "",
      list: "", // 当前页面所有的券
      dialogVisible: false, // 弹出层状态
      imgsrc: "", // 图片页面缓存地址
      placeholder: "", // 二维码地址
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      num: 1, // 编辑时新增的张数
      present: "", // 编辑时缓存的当前券数据
      value1: "", // 编辑时修改的时间参数
      show: false,
      page: 1,
      limit: 20,
      count:0
    };
  },

  mounted() {
    this.shopData = JSON.parse(sessionStorage.getItem("shopData")).shop;
    this.codeList();
  },

  methods: {
    delte() {
      // 点击关闭二维码时
      this.$router.go(0);
      this.show = false;
    },
    down() {
      // 点击下载图片时
      location.href = this.imgsrc + ".png";
    },
    qrCode(url) {
      // 点击生成图片
      let qrcode = new QRCode("qrcode", {
        width: 255, //图像宽度
        height: 255, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H, //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
      });
      this.time = util.getDays();
      this.show = true;
      qrcode.clear(); //清除二维码
      qrcode.makeCode(url); //生成另一个新的二维码
      setTimeout(() => {
        this.toImage();
      }, 500);
    },
    toImage() {
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      html2canvas(this.$refs.imageTofile, {
        backgroundColor: null,
      }).then((canvas) => {
        let url = canvas.toDataURL("image/png");
        this.imgsrc = url; // 把生成的base64位图片上传到服务器,生成在线图片地址
      });
    },
    codeList() {
      // 获取当前所有的固定码
      let data = {
        shopId: this.shopData.id,
        parkId: this.shopData.parkId,
        page: this.page,
        limit: this.limit,
      };
      this.$axios.post("shopFixCodeList", data).then((res) => {
        this.list = res.data;
        this.count = res.count;
      });
    },

    handleChange(value) {
      // 券新增数量
      this.num = value;
    },

    redraw(index) {
      // 点击券主体，生成二维码
      this.present = this.list[index];
      this.placeholder =
        "https://g.zaztservice.com/park-shop/scanQrFixCode?fixCodeId=" +
        this.present.id;
      this.qrCode(this.placeholder);
    },

    redact(index) {
      // 点击编辑
      this.dialogVisible = true;
      this.present = this.list[index];
      this.value1 = this.present.codeEndTime;
    },

    submit() {
      // 点击编辑中的确认
      let that = this;
      if (this.num <= 0) {
        util.hint(400, "新增张数不能小于0！");
        return false;
      }
      var data = that.present;
      data.codeEndTime = util.timeFormat(that.value1);
      data.total += that.num;
      data.count += that.num;
      that.$axios.post("shopFixCodeSave", data).then((res) => {
        console.log(res);
        if (res.code == 0) {
          util.hint(0, "保存成功！");
          that.close();
          that.codeList();
        } else {
          util.hint(res.code, res.msg);
        }
      });
    },

    handleClose(done) {
      // 点击弹层关闭时间
      done();
    },

    close() {
      // 点击弹层取消事件
      this.dialogVisible = false;
      this.num = 1;
      that.value1 = "";
    },

    del(index) {
      // 点击券中删除事件
      let that = this;
      this.$confirm("若删除当前固定码，该码会即时失效，是否删除？")
        .then((_) => {
          var data = {
            shopId: that.list[index].shopId,
            id: that.list[index].id,
          };
          that.$axios.post("shopFixCodeDelete", data).then((res) => {
            if (res.code == 0) {
              util.hint(0, "删除成功！");
              that.codeList();
            } else {
              util.hint(res.code, res.msg);
            }
          });
          // console.log(index);
        })
        .catch((_) => {});
    },

    // 当每页显示的数据条数发发生改变时（pageSize），触发此方法
    handleSizeChange(pageSize) {
      this.limit = pageSize;
      this.codeList();
    },
    // 当前页面显示的页码发生改变时（pageIndex），触发此方法
    // 用户点击页码或者上一页 下一页的按钮时，都会使pageIndex发生改变
    handleCurrentChange(pageIndex) {
      this.page = pageIndex;
      this.codeList();
    },
  },
};
</script>

<style lang="less" scoped>
@import url(../assets/css/qrcode.css);
.home {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 0.2rem;
  box-sizing: border-box;
  position: relative;

  .ticketList {
    width: 100%;
    max-height: 81%;
    border: 1px solid #ccc;
    padding: 0.1rem;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    overflow: auto;

    .codeList {
      width: 23%;
      height: 3.3rem;
      border: 1px solid #e4e4e4;
      position: relative;
      margin-right: 0.1rem;
      margin-bottom: 0.1rem;
      display: inline-block;
      border-radius: 10px;

      .el-icon-film {
        position: absolute;
        left: 2%;
        top: 50%;
        transform: translate(0, -50%);
        font-size: 0.3rem;
      }

      .ticketHone {
        position: absolute;
        left: 15%;
        text-align: left;
        font-size: 0.18rem;
        cursor: pointer;

        p {
          display: inline-block;
          width: 90%;
          height: 0.4rem;
          line-height: 0.4rem;
          border-bottom: 1px solid #e4e4e4;
          margin: 0;
        }

        p:first-child {
          font-size: 0.2rem;
          font-weight: bold;
          color: #f39b00;
        }
      }

      .operate {
        position: absolute;
        left: 15%;
        bottom: 0;
        display: inline-block;
        height: 0.5rem;
        line-height: 0.5rem;
        width: 80%;
        font-size: 0.3rem;
        text-align: left;

        .el-icon-edit-outline {
          color: #f39b00;
          cursor: pointer;
        }

        .el-icon-delete {
          color: #f56c6c;
          cursor: pointer;
        }
      }
    }

    .paging {
      width: 100%;
      text-align: center;
      padding: 0.2rem;
      box-sizing: border-box;
    }
  }

  .hint {
    height: 0.8rem;
    padding: 0.2rem;
    box-sizing: border-box;
    line-height: 0.4rem;
    text-align: left;
    border: 1px solid #cccccc;
    margin-top: 0.3rem;
    font-size: 0.25rem;
    color: #f39b00;
  }

  .el-dialog__wrapper {
    .el-dialog {
      .el-dialog__body {
        .compile {
          text-align: left;
          padding: 0 0 0 0.5rem;
          box-sizing: border-box;

          .el-input-number {
            width: 3rem;
            margin-left: 0.05rem;
          }

          p {
            .el-date-editor--datetime {
              width: 3rem;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/fixedList.vue